import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../mock';

const Navbar = () => {
  return (
    <nav className="w-full bg-[#0a0a0a] text-white border-t border-[#c9a961]/30">
      <div className="max-w-[1280px] mx-auto flex items-center justify-between px-4 md:px-8">
        <ul className="flex items-center overflow-x-auto no-scrollbar">
          {CATEGORIES.map((cat) => (
            <li key={cat.slug}>
              <Link
                to={cat.slug === 'home' ? '/' : `/category/${cat.slug}`}
                className="block px-4 lg:px-5 py-4 text-[12px] font-semibold uppercase tracking-[0.16em] hover:text-[#c9a961] transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            </li>
          ))}
        </ul>
        <div className="hidden md:flex items-center gap-2 pl-2">
          <button className="text-[10px] uppercase font-semibold tracking-[0.18em] border border-[#c9a961]/50 text-[#c9a961] px-3 py-1.5 hover:bg-[#c9a961] hover:text-black transition-colors">
            Derniers articles
          </button>
          <button className="text-[10px] uppercase font-semibold tracking-[0.18em] bg-[#8b2c3f] text-white px-3 py-1.5 hover:bg-[#6d1f2f] transition-colors">
            Articles populaires
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
